import React from 'react';
import './Project.css';

const ProjectPlan: React.FC = () => {
  return (
    <div className="plan-container">
      <h2>Project Plan</h2>
      <div className="plan-content">
        <div className="plan-section">
          <h3>Timeline</h3>
          <div className="timeline">
            <div className="timeline-item">
              <div className="timeline-header">
                <h4>Phase 1: Research & Planning</h4>
                <span className="timeline-date">Week 1-2</span>
              </div>
              <ul>
                <li>Market research</li>
                <li>User interviews</li>
                <li>Competitive analysis</li>
                <li>Initial project scope</li>
              </ul>
            </div>
            <div className="timeline-item">
              <div className="timeline-header">
                <h4>Phase 2: Design & Development</h4>
                <span className="timeline-date">Week 3-6</span>
              </div>
              <ul>
                <li>UI/UX design</li>
                <li>Technical architecture</li>
                <li>Core feature development</li>
                <li>Initial testing</li>
              </ul>
            </div>
            <div className="timeline-item">
              <div className="timeline-header">
                <h4>Phase 3: Testing & Launch</h4>
                <span className="timeline-date">Week 7-8</span>
              </div>
              <ul>
                <li>User testing</li>
                <li>Bug fixes</li>
                <li>Performance optimization</li>
                <li>Launch preparation</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="plan-section">
          <h3>Resources</h3>
          <div className="resources">
            <div className="resource-item">
              <h4>Team</h4>
              <ul>
                <li>Project Manager</li>
                <li>2 Developers</li>
                <li>1 Designer</li>
                <li>1 QA Engineer</li>
              </ul>
            </div>
            <div className="resource-item">
              <h4>Tools</h4>
              <ul>
                <li>Design: Figma</li>
                <li>Development: VS Code</li>
                <li>Testing: Jest</li>
                <li>Deployment: AWS</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectPlan;
